export const resources = {
    result: {
        200: {
            message: 'OK',
            description: 'The request has been successfully processed.'
        },
        202: {
            message: 'Accepted',
            description: 'The request has been accepted for processing.'
        },
        400: {
            message: 'Bad Request',
            description: 'Can\'t process the request because it\'s malformed or incorrect.'
        },
        401: {
            message: 'Unauthorized',
            description: 'Required authentication information is either missing or not valid for the resource.'
        },
        402: {
            message: 'Payment Required',
            description: 'The payment requirements for the API haven\'t been met.'
        },
        403: {
            message: 'Forbidden',
            description: 'Access is denied to the requested resource. The user might not have enough permission or might not have a required license.'
        },
        404: {
            message: 'Not Found',
            description: 'The requested resource doesn’t exist.'
        },
        405: {
            message: 'Method Not Allowed',
            description: 'The HTTP method in the request isn\'t allowed on the resource.'
        },
        406: {
            message: 'Not Acceptable',
            description: 'This service doesn’t support the format requested in the Accept header.'
        },
        409: {
            message: 'Conflict',
            description: 'The current state conflicts with what the request expects. For example, the specified parent folder might not exist.'
        },
        410: {
            message: 'Gone',
            description: 'The requested resource is no longer available at the server.'
        },
        411: {
            message: 'Length Required',
            description: 'A Content-Length header is required on the request.'
        },
        412: {
            message: 'Precondition Failed',
            description: 'A precondition provided in the request (such as an if-match header) doesn\'t match the resource\'s current state.'
        },
        413: {
            message: 'Request Entity Too Large',
            description: 'The request size exceeds the maximum limit.'
        },
        415: {
            message: 'Unsupported Media Type',
            description: 'The content type of the request is a format that isn\'t supported by the service.'
        },
        416: {
            message: 'Requested Range Not Satisfiable',
            description: 'The specified byte range is invalid or unavailable.'
        },
        422: {
            message: 'Unprocessable Entity',
            description: 'Can\'t process the request because it is semantically incorrect.'
        },
        423: {
            message: 'Locked',
            description: 'The resource that is being accessed is locked.'
        },
        429: {
            message: 'Too Many Requests',
            description: 'Client application has been throttled and shouldn\'t attempt to repeat the request until an amount of time has elapsed.'
        },
        500: {
            message: 'Internal Server Error',
            description: 'There was an internal server error while processing the request.'
        },
        501: {
            message: 'Not Implemented',
            description: 'The requested feature isn’t implemented.'
        },
        503: {
            message: 'Service Unavailable',
            description: 'The service is temporarily unavailable for maintenance or is overloaded. You may repeat the request after a delay, the length of which may be specified in a Retry-After header.'
        },
        504: {
            message: 'Gateway Timeout',
            description: 'The server, while acting as a proxy, didn\'t receive a timely response from the upstream server it needed to access in attempting to complete the request.'
        },
        507: {
            message: 'Insufficient Storage',
            description: 'The maximum storage quota has been reached.'
        },
        509: {
            message: 'Bandwidth Limit Exceeded',
            description: 'Your app has been throttled for exceeding the maximum bandwidth cap. Your app can retry the request again after more time has elapsed.'
        }
    }
};
